import { render } from 'solid-js/web';
import { TopBar } from './TopBar';

export function mountTopBar(
  mountEl: HTMLElement,
  onAbout: () => void,
  onReset: () => void,
): void {
  render(
    () => (
      <TopBar
        onAbout={onAbout}
        onReset={onReset}
      />
    ),
    mountEl,
  );
}
